import styles from "./Fieldset.module.css";
import PropTypes from "prop-types";

export default function Fieldset({ children, errorList = [] }) {
  return (
    <fieldset className={styles.Fieldset}>
      <div className={styles.inner}>{children}</div>
      {errorList?.length > 0 && (
        <ul className={styles.errors}>
          {errorList.map((error, index) => {
            return <li key={index}>{error}</li>;
          })}
        </ul>
      )}
    </fieldset>
  );
}

Fieldset.propTypes = {
  children: PropTypes.node.isRequired,
  errorList: PropTypes.arrayOf(PropTypes.string),
};
